/**
 * =============================================================================
 * mp-gift-wrap.js 
 * =============================================================================
 * 
 * =============================================================================
 */

var GiftWrap = {
  init: function() {
    if(!MP.Utilities.isCartPage()){
      return;
    }

    document.addEventListener("click", function(e){    
      if(e.target.classList.contains("mp-button-checkout")){
        if(document.querySelector('#mp-gift-wrap:checked')) {
          // Add the appropriate product
          var data = { quantity: 1, id: document.querySelector('#mp-gift-wrap-option').value };
          window.disableNextMinicartOpen = true;
          MP.Extensions.Cart.add(data).finally(function(data) {
            document.querySelector("#mp-button-checkout-hidden").click();
          });
        } else {
          document.querySelector("#mp-button-checkout-hidden").click();
        }
      }
    });
  }

};

export default GiftWrap;